// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"172":"60cbc29f","199":"a76fb2fd","254":"d1288f0d","404":"5e588df7","478":"e96783ae","797":"19a38766"}[chunkId] + ".chunk.css";
};